import { CommandAction } from "src/app/abstract/command/command-action.service";
import { WidgetsRowModel } from "src/app/models/widgets/widgets-row.model";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";

@Injectable()
export class CommandRowService extends CommandAction {

    public execute(parent: WidgetsAbstract, widget: WidgetsAbstract): WidgetsRowModel {
        const newRow = new WidgetsRowModel();
        newRow.parentId =  parent.id;
        return newRow;              
    }
}
